import { HttpContext } from '@angular/common/http';
import { LOADER_MESSAGE } from '@core/api/interceptors/loader.interceptor';

export function createLoaderContext(message: string): HttpContext {
  return new HttpContext().set(LOADER_MESSAGE, message);
}
